import React, { useEffect, useState } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import Skeleton from "react-loading-skeleton";
import "react-datepicker/dist/react-datepicker.css";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';
import {
  base_url,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  STATUS_CLOSED,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  AUDITOR_ROLE,
} from "./../utilities";
import FileSaver from "file-saver";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import { Form, Modal } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";

const DocumentRepository = (props) => {
  let ltwo = props.loading;
  const [loading, setLoading] = useState(true);
  const [modalBusinessDetailsShow, setModalBusinessDetailsShow] =
    useState(false);
  const [modalInvDetailsShow, setModalInvDetailsShow] = useState(false);
  const [defaultvalue, setDefaultValue] = useState(false);
  const [allInvestorsCount, setAllInvestorCount] = useState();
  const [totalInvestment, setTotalInvestmentInDinar] = useState();
  const [totalInvestmentDolor, setTotalInvestmentInDolor] = useState();
  const [allInvestorsInvestCount, setAllInvestorInvestCount] = useState();
  const [totalInvestmentInvest, setTotalInvestmentInvestInDinar] = useState();
  const [totalInvestmentDolorInvest, setTotalInvestmentInvestInDolor] =
    useState();
  const [investorData, setInvestorData] = useState([]);
  const [investorFilter, setInvestorFilter] = useState([]);
  const [businessFilter, setBusinessFilter] = useState([]);
  const [businsDocRepo, setBusinsDocRepo] = useState([]);
  let count = businessFilter.length;

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const [fifthValue, setFifthValue] = useState([]);

  const [busFirstValue, setBusFirstValue] = useState([]);
  const [busSecondValue, setBusSecondValue] = useState([]);
  const [busThirdValue, setBusThirdValue] = useState([]);
  const [busFourthValue, setBusFourthValue] = useState([]);
  const [busFifthValue, setBusFifthValue] = useState([]);
  const[displayedDataBus,setDisplayedDataBus]=useState([]);
  const[displayedDataInv,setDisplayedDataInv]=useState([]);
  const handleChangeAllInputBus=(e)=>{
    const value = e.target.value;
if(value.length>2)
{
  axios
      .post(base_url+'business-master/get_all_business_documents_repository',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setBusinessFilter(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{
  setBusinessFilter(displayedDataBus);
}
  }

  const handleChangeAllInputInv=(e)=>{
    const value = e.target.value;
if(value.length>2)
{
  axios
      .post(base_url+'inv_master/get_all_investor_documents_repository',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setInvestorFilter(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{
  setInvestorFilter(displayedDataInv);
}
  }
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
    if (Cookies.get("is_first_tab") == "false") {
      document.getElementById("businessdocrepo-tab").classList.remove("active");
      document.getElementById("investordocrepo-tab").classList.add("active");
      document
        .getElementById("businessdocrepo-tab-pane")
        .classList.remove("active");
      document
        .getElementById("investordocrepo-tab-pane")
        .classList.add("active");
      setDefaultValueForInvestor(true);
    } else {
      setDefaultValueForInvestor(false);
      document.getElementById("businessdocrepo-tab").classList.add("active");
      document.getElementById("investordocrepo-tab").classList.remove("active");
      document
        .getElementById("businessdocrepo-tab-pane")
        .classList.add("active");
      document
        .getElementById("investordocrepo-tab-pane")
        .classList.remove("active");
    }
    axios
      .post(base_url + "inv_master/get_all_investor_documents_repository")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined) {
          setLoading(false);
          let toal_amount_inv = 0;
          let toal_amount_usd_inv = 0;
          data.forEach((elemInvestmentAmount, index) => {
            elemInvestmentAmount.serial_number = index + 1;

            if (elemInvestmentAmount.currency_type == LOAN_CURRENCY_TYPE_USD) {
              toal_amount_usd_inv =
                toal_amount_usd_inv +
                parseInt(elemInvestmentAmount.committed_principal);
            }
          });

          setInvestorData(data);
          setInvestorFilter(data);
          setAllInvestorCount(data.length);
          setFourthValue(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setFifthValue(data);
          setDisplayedDataInv(data);
          setTotalInvestmentInDinar(toal_amount_inv);
          setTotalInvestmentInDolor(toal_amount_usd_inv);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });
    axios
      .post(base_url + "business-master/get_all_business_documents_repository")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined) {
          let toal_amount = 0;
          let toal_amount_usd = 0;
          data.forEach((each_record, index) => {
            each_record.serial_number = index + 1;
            if (
              each_record.admin_request_loan_currency ==
                LOAN_CURRENCY_TYPE_BHD &&
              (each_record.status == STATUS_PROCESSED ||
                each_record.status == STATUS_CLOSED)
            ) {
              toal_amount = toal_amount + parseInt(each_record.loan_amount);
            }
            if (
              each_record.admin_request_loan_currency ==
                LOAN_CURRENCY_TYPE_USD &&
              (each_record.status == STATUS_PROCESSED ||
                each_record.status == STATUS_CLOSED)
            ) {
              toal_amount_usd =
                toal_amount_usd + parseInt(each_record.loan_amount);
            }
          });
          setLoading(false);
          setBusinsDocRepo(data);
          setBusinessFilter(data);
          setBusFirstValue(data);
          setBusSecondValue(data);
          setBusThirdValue(data);
          setBusFourthValue(data);
          setBusFifthValue(data);
          setDisplayedDataBus(data);
          setAllInvestorInvestCount(data.length);
          setTotalInvestmentInvestInDinar(toal_amount);
          setTotalInvestmentInvestInDolor(toal_amount_usd);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });
  }, []);

  const navigate = useNavigate();
  const [coutofdocs, setCountofDocs] = useState(0);
  const [InvCountofDocs, setInvCountofDocs] = useState(0);

  let coutofTotalDocs = 0;
  let coutof_Inv_TotalDocs = 0;
  let over_due = 0;
  let inv_over_due = 0;
  let is_exprired_count = 0;
  let Inv_is_exprired_count = 0;
  const [overDueDate, setOverDueDate] = useState(0);
  const [InvoverDueDate, setInvOverDueDate] = useState(0);
  const [countOfCloseToExpiry, setCountOfCloseToExpiry] = useState(0);
  const [InvcountOfCloseToExpiry, setInvCountOfCloseToExpiry] = useState(0);

  const today = new Date();
  const nextMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  useEffect(() => {
    businessFilter.map((item) => {
      let list_of_expired_docs = [];
      item.list_of_documents.forEach((ele, ind1) => {
        if (ele.expiry_date !== undefined || ele.expiry_date !== null) {
          if (ele.expiry_date < new Date().getTime()) {
            over_due = over_due + 1;
          }
          if (
            ele.expiry_date > new Date().getTime() &&
            ele.expiry_date < nextMonth
          ) {
            ele.is_expired = true;
            list_of_expired_docs.push(ele);
            is_exprired_count = is_exprired_count + 1;
          } else {
            ele.is_expired = false;
          }
        }
      });
      item.list_of_expired_docs = list_of_expired_docs;
      setCountOfCloseToExpiry(is_exprired_count);
      setOverDueDate(over_due);
      coutofTotalDocs = coutofTotalDocs + item.list_of_documents.length;
    });

    investorFilter.map((item) => {
      let inv_list_of_expired_docs = [];
      item.list_of_documents.forEach((ele, ind1) => {
        if (ele.expiry_date !== undefined || ele.expiry_date !== null) {
          if (ele.expiry_date < new Date().getTime()) {
            inv_over_due = inv_over_due + 1;
          }
          if (
            ele.expiry_date > new Date().getTime() &&
            ele.expiry_date < nextMonth
          ) {
            ele.is_expired = true;
            inv_list_of_expired_docs.push(ele);
            Inv_is_exprired_count = Inv_is_exprired_count + 1;
          } else {
            ele.is_expired = false;
          }
        }
      });
      item.inv_list_of_expired_docs = inv_list_of_expired_docs;
      setInvCountOfCloseToExpiry(Inv_is_exprired_count);
      setInvOverDueDate(inv_over_due);
      coutof_Inv_TotalDocs =
        coutof_Inv_TotalDocs + item.list_of_documents.length;
    });

    setCountofDocs(coutofTotalDocs);
    setInvCountofDocs(coutof_Inv_TotalDocs);
  }, [businessFilter, investorFilter]);

  const goToAdminDashboard = () => {
    navigate("/admindashboard");
  };
  function exportToExcel() {
    let sample_data_array = [];
    businessFilter.forEach((elem) => {
      let xl_object = {
        "Business Name": elem.business_name,
        "Ref No": elem.business_reference_no,
        "Close To Expiry Date": elem.committed_principal,
        "Uploaded By": elem.list_of_documents.created_by,
        "Validated By": elem.list_of_documents.validated_by,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "Businesses_document_repository_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  function invexportToExcel() {
    let sample_data_array = [];
    investorFilter.forEach((elem) => {
      let xl_object = {
        "Business Name": elem.business_name,
        "Ref No": elem.business_reference_no,
        "Close To Expiry Date": elem.committed_principal,
        "Uploaded By": elem.list_of_documents.created_by,
        "Validated By": elem.list_of_documents.validated_by,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "Businesses_document_repository_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  const [initialValueInv, setInitialValueInv] = useState('')
  const [secondFilterValueInv, setSecondFilterValueInv] = useState('')
  const [thirdFilterValueInv, setThirdFilterValueInv] = useState('')
  const [fourthFilterValueInv, setFourthFilterValueInv] = useState('')

  const clearFiltersBusiness = () => {
    setBusinessFilter(businsDocRepo);
    setDefaultValue(true);
    setBusFourthValue(businsDocRepo);
    setBusFifthValue(businsDocRepo);
    setBusFirstValue(businsDocRepo);
    setBusSecondValue(businsDocRepo);
    setBusThirdValue(businsDocRepo);
    setInitialValue("")
setSecondFilterValue("")
setThirdFilterValue("")
setFifthFilterValue("")
  };
  const clearFiltersInv = () => {
    setInvestorFilter(investorData);
    setDefaultValue(true);
    setFourthValue(investorData);
    setFifthValue(investorData);
    setFirstValue(investorData);
    setSecondValue(investorData);
    setThirdValue(investorData);
  };
  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "investor" && secondFilterValueInv ==='' && thirdFilterValueInv ==='' && fourthFilterValueInv==='') {
      setInitialValueInv("investor")
      let f = firstValue.filter((item) => {
        if (value === item.investor_name) {
          return item;
        }
        if (value === "All") {
          setInitialValueInv("")
          return item;
        }
      });
      setInvestorFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }

    if (name === "inv_refNo" && initialValueInv ==='' && thirdFilterValueInv ==='' && fourthFilterValueInv==='') {
      secondFilterValueInv("inv_refNo")
      let f = secondValue.filter((item) => {
        if (value === item.investor_reference_no) {
          return item;
        }
        if (value === "All") {
          secondFilterValueInv("")
          return item;
        }
      });
      setInvestorFilter(f);
      setFirstValue(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "inv_refNo" && initialValueInv !=='') {
      let f = secondValue.filter((item) => {
        if (value === item.investor_reference_no) {
          return item;
        }
        if (value === "All") {
          secondFilterValueInv("")
          return item;
        }
      });
      setInvestorFilter(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "invuploadby" && initialValueInv ==='' && secondFilterValueInv ==='' && fourthFilterValueInv==='') {
      setThirdFilterValueInv("invuploadby")
      let f = thirdValue.filter((item) => {
        if (value === item.list_of_documents[0]?.created_by) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValueInv("")
          return item;
        }
      });
      setInvestorFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setFourthValue(f);
    }
    if (name === "inv_validatedby") {
      let f = fourthValue.filter((item) => {
        if (value === item.list_of_documents[0]?.validated_by) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setInvestorFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setThirdValue(f);
      setFifthValue(f);
    }

    setDefaultValue(false);
  };

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fifthFilterValue, setFifthFilterValue] = useState('')

  const handleChangeInputBusns = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "business" && secondFilterValue ==='' && thirdFilterValue ==='' && fifthFilterValue ==='' ) {
      setInitialValue("business")
      let f = busFirstValue.filter((item) => {
        if (value === item.business_name) {
          return item;
        }
        if (value === "All") {
          setInitialValue("")
          return item;
        }
      });
      setBusinessFilter(f);
      setBusSecondValue(f);
      setBusThirdValue(f);
      setBusFourthValue(f);
      setBusFifthValue(f);
    }

    if (name === "refNo" && initialValue==='' && thirdFilterValue ==='' && fifthFilterValue ==='' ) {
      setSecondFilterValue("refNo")
      let f = busSecondValue.filter((item) => {
        if (value === item.business_reference_no) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setBusinessFilter(f);
      setBusFirstValue(f);
      setBusThirdValue(f);
      setBusFourthValue(f);
      setBusFifthValue(f);
    }
    if (name === "uploadby" && initialValue==='' && secondFilterValue ==='' && fifthFilterValue ==='' ) {
      setThirdFilterValue("uploadby")
      let f = busThirdValue.filter((item) => {
        if (value === item.created_by) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setBusinessFilter(f);
      setBusFirstValue(f);
      setBusSecondValue(f);
      setBusFourthValue(f);
      setBusFifthValue(f);
    }
    // if (name === "rate") {
    //   let NumberValue = Number(value);
    //   let f = busFourthValue.filter((item) => {
    //     if (NumberValue === item.profit) {
    //       return item;
    //     }
    //     if (value === "All") {
    //       return item;
    //     }
    //   });
    //   setBusinessFilter(f);
    //   setBusFirstValue(f);
    //   setBusSecondValue(f);
    //   setBusThirdValue(f);
    //   setBusFifthValue(f);
    // }
    if (name === "bus_validatedby" && initialValue==='' && secondFilterValue ==='' && thirdFilterValue ==='') {
setFifthFilterValue("bus_validatedby")
let f = busFifthValue.filter((item) => {
  if (value === item.list_of_documents[0]?.validated_by) {
    return item;
  }
  if (value === "All") {
          setFifthFilterValue("")
          return item;
        }
      });
      setBusinessFilter(f);
      setBusFirstValue(f);
      setBusSecondValue(f);
      setBusThirdValue(f);
      setBusFourthValue(f);
    }
    setDefaultValue(false);
  };

  const uniqueBusinessName = [
    ...new Set(busFirstValue.map((d) => d.business_name)),
  ];
  const uniqueInvestorName = [
    ...new Set(firstValue.map((d) => d.investor_name)),
  ];
  const uniqueInvUploadedBy = [
    ...new Set(thirdValue.map((d) => d.list_of_documents[0]?.created_by)),
  ];
  const uniquelrefNo = [
    ...new Set(busSecondValue.map((d) => d.business_reference_no)),
  ];
  const uniqueInvrefNo = [
    ...new Set(secondValue.map((d) => d.investor_reference_no)),
  ];
  const uniqueInvValidatedBy = [
    ...new Set(fourthValue.map((d) => d.list_of_documents[0]?.validated_by)),
  ];
  const uniqueBusUpload = [...new Set(busThirdValue.map((d) => d.created_by))];
  const uniqueBusValidatedBy = [
    ...new Set(busFifthValue.map((d) => d.list_of_documents[0]?.validated_by)),
  ];
  const [defaultvalueInvestor, setDefaultValueForInvestor] = useState(false);
  const investorClick = () => {
    Cookies.set("is_first_tab", true, { expires: 7 });
    setDefaultValueForInvestor(false);
  };
  const newInvestorIntrestsClick = () => {
    Cookies.set("is_first_tab", false, { expires: 7 });
    setDefaultValueForInvestor(true);
  };
  const columns = [
    {
      title: "Business Name",
      field: "business_name",
    },
    {
      title: "Ref No.",
      field: "business_reference_no",
    },
    {
      title: "Close To Expiry Date",
      field: "investor_name",
    },
    {
      title: "Uploaded By",
      field: "uploaded_by",
    },
    {
      title: "Validated By",
      field: "validated_by",
      currency: "currency_type",
    },

    {
      title: "Actions",
      field: "image",
      image: "./images/icons/double_arrow.svg",
      datatopass: "",
    },
  ];
  const columnstwo = [
    { title: "Investor Name", field: "investor_name" },
    { title: "Ref No", field: "investor_reference_no" },
    { title: "Close To Expiry Date", field: "loan_reference_no" },
    {
      title: "Uploaded By",
      field: "uploaded_by",
      currency: "admin_request_loan_currency",
    },
    { title: "Validated By", field: "validated_by" },
    {
      title: "Actions",
      field: "",
      image: "./images/paperrocket.svg",
      datatopass: "",
    },
  ];

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...businsDocRepo].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setBusinessFilter(sortedData);
  };

  const handleSorttwo = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...investorFilter].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvestorFilter(sortedData);
  };

  const [businessData, setBusinessData] = useState([]);
  const [invData, setInvData] = useState([]);

  const dataTopass = (data) => {
    setBusinessData(data);
    setModalBusinessDetailsShow(true);
  };
  const dataTopassforModalTwo = (data) => {
    setInvData(data);
    setModalInvDetailsShow(true);
  };

  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])

  return (
    <div>
      <AdminNavBarMain />

      <div className="row admin_body_main bg-transparent">
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
            <h5
              className="admin_serv mb-1"
              onClick={() => goToAdminDashboard(true)}
            >
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls"
              />
              &nbsp; Documents Repository
            </h5>
          </div>
        </div>
        {defaultvalueInvestor == false ? (
          <div className="container p-0">
            <div className="row d-flex justify-content-between mb-2">
              <div className="col-md-2 mb-3 mb-md-0  ">
                <div className=" b_style_new ms-0">
                  <span> No. of Businessess</span>
                  <p className="p_style">{allInvestorsInvestCount}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" n_style_new">
                  <span>Total Documents</span>
                  <p className="p_style">{coutofdocs}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" g_style_new">
                  <span>Close to Expiry</span>
                  <p className="p_style">{countOfCloseToExpiry}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" r_style_new">
                  <span>Overdue</span>
                  <p className="p_style">{overDueDate}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInputBus(e)}
              />
            </div>
              <div className="col text-end">
                <div className=" count_of_records_ALLSR">
                  <span>No.of Records : {count}</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container p-0">
            <div className="row d-flex justify-content-between mb-2">
              <div className="col-md-2 mb-3 mb-md-0  ">
                <div className=" b_style_new ms-0 ">
                  <span> No.of Investors</span>
                  <p className="p_style">{allInvestorsCount}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" n_style_new">
                  <span>Total Documents</span>
                  <p className="p_style">{InvCountofDocs}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" g_style_new">
                  <span>Close to Expiry</span>
                  <p className="p_style">{InvcountOfCloseToExpiry}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" r_style_new">
                  <span>Overdue</span>
                  <p className="p_style">{InvoverDueDate}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInputInv(e)}
              />
            </div>
              <div className="col text-end"></div>
            </div>
          </div>
        )}
      </div>

      <div className="">
        <div className="AllInv_top_tab pe-5 ps-5">
          <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={investorClick}
                className="nav-link-inv  p-1"
                id="businessdocrepo-tab"
                data-bs-toggle="tab"
                data-bs-target="#businessdocrepo-tab-pane"
                type="button"
                role="tab"
                aria-controls="businessdocrepo-tab-pane"
                aria-selected="true"
              >
                <h3>Business Documents Repository</h3>
              </button>
            </li>
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={newInvestorIntrestsClick}
                className="nav-link-inv p-1 x"
                id="investordocrepo-tab"
                data-bs-toggle="tab"
                data-bs-target="#investordocrepo-tab-pane"
                type="button"
                role="tab"
                aria-controls="investordocrepo-tab-pane"
                aria-selected="false"
              >
                <h3>Investors Documents Repository</h3>
              </button>
            </li>
          </ul>
        </div>
        <div
          className="tab-content idiv_inv_left_card_text pe-5 ps-5"
          id="myTabContent"
        >
          <div
            className="tab-pane fade show "
            id="businessdocrepo-tab-pane"
            role="tabpanel"
            aria-labelledby="businessdocrepo-tab"
            tabIndex="0"
          >
            <div>
              <div className="row mb-3 gap-3">
                <div className="col">
                  <label htmlFor="business" className="form-label">
                    <p>Search by Business</p>
                  </label>
                  <select
                    id="business"
                    className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                    aria-label="form-select example"
                    name="business"
                    autoComplete="off"
                    onChange={handleChangeInputBusns}
                  >
                    <option selected={defaultvalue}>All</option>

                    {uniqueBusinessName.map((type) => {
                      return <option key={type}>{type}</option>;
                    })}
                  </select>
                </div>

                <div className="col-lg">
                  <label htmlFor="uploadby" className="form-label">
                    <p>Uploaded By</p>
                  </label>
                  <select
                    id="uploadby"
                    className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                    aria-label="form-select example"
                    name="uploadby"
                    autoComplete="off"
                    onChange={handleChangeInputBusns}
                  >
                    <option selected={defaultvalue}>All</option>
                    {uniqueBusUpload.map((type) => {
                      return <option key={type}>{type}</option>;
                    })}
                  </select>
                </div>

                <div className="col-lg">
                  <label htmlFor="refNo" className="form-label">
                    <p>Ref No.</p>
                  </label>
                  <select
                    id="refNo"
                    className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                    aria-label="form-select example"
                    name="refNo"
                    autoComplete="off"
                    onChange={handleChangeInputBusns}
                  >
                    <option selected={defaultvalue}>All</option>
                    {uniquelrefNo.map((refno) => {
                      return <option key={refno}>{refno}</option>;
                    })}
                  </select>
                </div>

                <div className="col-lg">
                  <label htmlFor="bus_validatedby" className="form-label">
                    <p>Validated By</p>
                  </label>
                  <select
                    className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                    id="bus_validatedby"
                    onChange={handleChangeInputBusns}
                    name="bus_validatedby"
                  >
                    <option selected={defaultvalue}>All</option>
                    {uniqueBusValidatedBy.map((data, index1) => {
                      return <option key={data}>{data}</option>;
                    })}
                  </select>
                </div>

                <div className=" col align-self-end">
                  <button className="blue_btn" onClick={clearFiltersBusiness}>
                    Clear All Filters
                  </button>
                </div>

                <div className="col btn_style">
                  <button className="blue_btn " onClick={exportToExcel} disabled={roleCode===AUDITOR_ROLE}>
                    Download XLS
                  </button>
                </div>
              </div>
            </div>
            <div className="doc_repo_inv_table">
              <Table
                striped
                // bordered
                className="bg-white ps-4 pe-4 text-center "
              >
                <thead className="">
                  <tr className="text-start">
                    {columns.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSort(column.field)}
                            className="Cpointer"
                          >
                            {ltwo || loading ? (
                              <Skeleton width={100} height={15} />
                            ) : (
                              <div>
                                {column.title !== "Actions" ? (
                                  <>
                                    {column.title}
                                    &#9662;
                                  </>
                                ) : (
                                  column.title
                                )}
                              </div>
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {businessFilter.map((data, index1) => {
                    let exp_doc = 0;
                    return (
                      <tr key={index1} className="new_inv_interst_table">
                        <td>
                          {data.business_name == undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.business_name
                              )}
                            </div>
                          )}
                        </td>
                        <td>
                          {data.business_reference_no == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.business_reference_no
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <b className="fs-6">
                              {data.kyc_expiry_date && moment(data.kyc_expiry_date).isValid() 
                              ? moment(data.kyc_expiry_date).format("DD MMM YYYY")
                              : "" }
                            </b>
                          )}
                          <br />
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <p>
                              {exp_doc === 0
                                ? "-"
                                : exp_doc === 1
                                ? exp_doc + " Document"
                                : exp_doc + " Documents"}
                            </p>
                          )}
                        </td>

                        <td>
                          {data.created_by ===
                          undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.created_by
                          )}
                        </td>
                        <td>
                          {data.validated_by ===
                          undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.validated_by
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <img
                              className="Cpointer"
                              src="./images/icons/blue_eye.svg"
                              alt=""
                              onClick={() => dataTopass(data)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          <div
            className="tab-pane fade show"
            id="investordocrepo-tab-pane"
            role="tabpanel"
            aria-labelledby="investordocrepo-tab"
            tabIndex="0"
          >
            <div className="row mb-3 gap-3">
              <div className="col">
                <label htmlFor="investor" className="form-label">
                  <p>Search by investor</p>
                </label>
                <select
                  id="investor"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="investor"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>

                  {uniqueInvestorName.map((type) => {
                    return <option key={type}>{type}</option>;
                  })}
                </select>
              </div>

              <div className="col">
                <label htmlFor="invuploadby" className="form-label">
                  <p>Uploaded By</p>
                </label>
                <select
                  id="invuploadby"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="invuploadby"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueInvUploadedBy.map((type) => {
                    return <option key={type}>{type}</option>;
                  })}
                </select>
              </div>

              <div className="col-lg">
                <label htmlFor="inv_refNo" className="form-label">
                  <p>Ref No.</p>
                </label>
                <select
                  id="inv_refNo"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="inv_refNo"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueInvrefNo.map((refno) => {
                    return <option key={refno}>{refno}</option>;
                  })}
                </select>
              </div>

              <div className="col-lg">
                <label htmlFor="inv_validatedby" className="form-label">
                  <p>Validated By</p>
                </label>
                <select
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  id="inv_validatedby"
                  onChange={handleChangeInput}
                  name="inv_validatedby"
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueInvValidatedBy.map((data) => {
                    return <option key={data}>{data}</option>;
                  })}
                </select>
              </div>

              <div className=" col align-self-end">
                <button className="blue_btn" onClick={clearFiltersInv}>
                  Clear All Filters
                </button>
              </div>

              <div className="col btn_style">
                <button className="blue_btn " onClick={invexportToExcel} disabled={roleCode===AUDITOR_ROLE}>
                  Download XLS
                </button>
              </div>
            </div>
            <div className="doc_repo_inv_table">
              <Table
                striped
                // bordered
                className="bg-white ps-4 pe-4 text-center "
              >
                <thead className="">
                  <tr>
                    {columnstwo.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSorttwo(column.field)}
                            className={`Cpointer ${
                              column.title === "Actions"
                                ? "text-start"
                                : column.title === "Investor Name"
                                ? "text-start ps-4"
                                : ""
                            }`}
                          >
                            {ltwo || loading ? (
                              <Skeleton width={100} height={15} />
                            ) : (
                              <div>
                                {column.title !== "Actions" ? (
                                  <p className="text-black table_data_header_styl">
                                    {" "}
                                    {column.title} &#9662;
                                  </p>
                                ) : (
                                  column.title
                                )}
                              </div>
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {investorFilter.map((data, index) => {
                    let exp_doc = 0;
                    let inv_first_exp_date;
                    data.list_of_documents.map((each_doc) => {
                      if (each_doc.is_expired === true) {
                        exp_doc = exp_doc + 1;
                      }
                      if (
                        data.inv_list_of_expired_docs &&
                        data.inv_list_of_expired_docs.length > 0
                      ) {
                        let minimum_expiry_date =
                          data.inv_list_of_expired_docs[0].expiry_date;
                        data.inv_list_of_expired_docs.map((current) => {
                          if (minimum_expiry_date > current.expiry_date) {
                            minimum_expiry_date = current.expiry_date;
                          }
                        });
                        inv_first_exp_date = minimum_expiry_date;
                      }
                    });
                    return (
                      <tr key={index} className="new_inv_interst_table">
                        <td>
                          {data.investor_name === undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div className="text-start ps-4">
                                  {data.investor_name}
                                </div>
                              )}
                            </div>
                          )}
                        </td>
                        <td>
                          {data.investor_reference_no === undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.investor_reference_no
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <b className="fs-6">
                             {data.kyc_expiry_date && moment(data.kyc_expiry_date).isValid() 
                              ? moment(data.kyc_expiry_date).format("DD MMM YYYY")
                              : "" }
                            </b>
                          )}
                          <br />
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <p>
                              {exp_doc === 0
                                ? "-"
                                : exp_doc === 1
                                ? exp_doc + " Document"
                                : exp_doc + " Documents"}
                            </p>
                          )}
                        </td>
                        <td>
                          {data.list_of_documents[0]?.created_by ===
                          undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.list_of_documents[0]?.created_by
                          )}
                        </td>
                        <td>
                          {data.validated_by ===
                          undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.validated_by
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <img
                              className="Cpointer d-flex ps-4"
                              src="./images/icons/blue_eye.svg"
                              alt=""
                              onClick={() => dataTopassforModalTwo(data)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <BusDocRepoModal
              data={businessData}
              show={modalBusinessDetailsShow}
              onHide={() => setModalBusinessDetailsShow(false)}
              roleCode={roleCode}
            />
            <InvDocRepoModal
              data={invData}
              show={modalInvDetailsShow}
              onHide={() => setModalInvDetailsShow(false)}
              roleCode={roleCode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentRepository;

export const BusDocRepoModal = (props) => {
  let data = props.data;
  let loading = props.loading;
  let ltwo = props.ltwo;
  const columns = [
    { title: "Type" },
    { title: "Action" },
    { title: "Select Expiry Date" },
  ];

  const [busnsdocs, setBusnsDocs] = useState([]);

  let doc = data.kyc_all_documents;
  useEffect(() => {
    if (doc !== "" || doc !== undefined) {
      doc?.map((item) => {
        item.expiry_date =
          item.expiry_date !== undefined || item.expiry_date !== null
            ? item.expiry_date
            : null;
        item.validated_by = Cookies.get("admin_user_name");
      });
      setBusnsDocs(doc);
    }
  }, [doc]);

  const handleDownload = async (doc) => {
    try {
      const response = await fetch(doc.document_url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = data.business_name + "_" + doc.document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose = () => {
    props.onHide();
  };

  const handleRenwDoc = () => {
    let doc_object = [];
    busnsdocs.map((eachDoc) => {
      let each_doc = {
        _id: eachDoc._id,
        entity_type: eachDoc.entity_type,
        entity_id: eachDoc.entity_id,
        expiry_date: eachDoc.expiry_date,
        validated_by: eachDoc.validated_by,
        admin_user_id: Cookies.get("admin_user_id"),
        admin_user_name: Cookies.get("admin_user_name"),
      };
      doc_object.push(each_doc);
    });
    axios
      .post(base_url + "documents-type/update_document", doc_object)
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Notified Successfully", {
            toastId: 4,
          });
          props.onHide();

          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else {
          toast.error("Error occurred", {
            toastId: 2,
          });
        }
      });
  };

  const handleDateChange = (e, id, index) => {
    let sch = [...busnsdocs];
    let current_date = parseInt(
      Math.round(new Date(e.target.value).getTime() / 1000) + "000"
    );
    sch[index]["expiry_date"] = current_date;
    setBusnsDocs(sch);
  };
  const [show, setShow] = useState(false);

  const [selectedDoc, setSelected] = useState([]);

  const handleShowReject = (value) => {
    setSelected(value);
    setShow(true);
  };
  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const handleCloseReject = () => {
    //hit the api from rejection api here
    let document_id = { document_id: selectedDoc.document_id };
    axios
      .post(base_url + "documents-type/delete_document", document_id)
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);
          toast.success("Deleted Successfully", {
            toastId: 4,
          });
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        onHide={handleClose}
        closeButton
        className="modal_title"
        style={{ height: "55px" }}
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Business Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-2" style={{ height: "28rem" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="row mb-3">
              <div className="col mb-3">
                <p className="text_st">Business Name</p>
                <div className="bolder_text">
                  {data.business_name === undefined || data.business_name === ""
                    ? "-"
                    : data.business_name}
                </div>

                <div className="mt-3">
                  <p className="text_st">Uploaded By</p>
                  <div className="bolder_text">
                    {data.created_by === undefined || data.created_by === ""
                      ? "-"
                      : data.created_by}
                  </div>
                </div>
              </div>

              <div className="col">
                <p className="text_st">Bahrain CPR</p>
                <div className="bolder_text">
                  {data.bahrain_cpr === undefined || data.bahrain_cpr === ""
                    ? "-"
                    : data.bahrain_cpr}
                </div>

                <div className="mt-3">
                  <p className="text_st">Validated By</p>
                  <div className="bolder_text">
                    {data.validated_by === undefined || data.validated_by === ""
                      ? "-"
                      : data.validated_by}
                  </div>
                </div>
              </div>

              <div className="col">
                <p className="text_st">National ID</p>
                <div className="bolder_text">
                  {data.emirates_id === undefined || data.emirates_id === ""
                    ? "-"
                    : data.emirates_id}
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>

        <div className="col-lg-9">
          <div className="row d-flex">
            <div className="col"></div>
            <div className="col-lg-2"></div>
            <div className="col-lg-4 fw-bolder mb-2">
              {doc?.length === 0 ? (
                <div className="no_doc_styl">No Documents</div>
              ) : (
                "Select Expiry"
              )}
            </div>
          </div>
        </div>

        <div className="document_tab_modal col-lg-9">
          {busnsdocs?.map((doc, index) => {
            return (
              <>
                <div className="row d-flex mt-3">
                  <div
                    className="col-lg-5"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={doc.document_type}
                  >
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : doc.document_type.length > 25 ? (
                      doc.document_type.slice(0, 25) + ".."
                    ) : (
                      doc.document_type
                    )}
                    <p>
                      {doc.expiry_date === null
                        ? ""
                        : "Expiry Date: " +
                          moment(doc.expiry_date).format("DD MMM YYYY")}
                    </p>
                  </div>
                  <div className="doc_icon_repo col-lg-2">
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : (
                      <div className="kyc_tab">
                        <div className="" style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <a
                            style={{ display: "table-cell" }}
                            href={doc.document_url}
                            target="_blank"
                          >
                            <img
                              className=""
                              src="./images/icons/blue_eye.svg"
                              alt=""
                            />
                          </a>
                        </div>
                        <div className=" ps-3 " style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }} >
                          <img
                            className="pb-1 Cpointer"
                            src="./images/down.svg"
                            alt=""
                            onClick={() => handleDownload(doc)}
                          />
                        </div>
                        <div style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <i
                            className=" del_bin_style fa-solid fa-trash"
                            onClick={() => handleShowReject(doc)}
                          ></i>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="expiry_date_pickr col-lg-4 ps-4">
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : (
                      <div>
                        <input
                          autoFocus
                          id="paid_date"
                          type="date"
                          className="form-control rounded custm_border shadow-sm"
                          onChange={(e) => handleDateChange(e, doc._id, index)}
                          placeholder="DD MMM YYYY"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            onClick={handleRenwDoc}
            disabled={props.roleCode===AUDITOR_ROLE}
          >
            Notify To Renew Documents
          </button>
        </div>
      </Modal.Footer>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to delete?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};

export const InvDocRepoModal = (props) => {
  let data = props.data;
  let loading = props.loading;
  let ltwo = props.ltwo;

  const [docs, setDocs] = useState([]);

  let doc = data.kyc_all_documents;
  useEffect(() => {
    if (doc !== "" || doc !== undefined) {
      doc?.map((item) => {
        item.expiry_date =
          item.expiry_date !== undefined || item.expiry_date !== null
            ? item.expiry_date
            : null;
        item.validated_by = Cookies.get("admin_user_name");
      });
      setDocs(doc);
    }
  }, [doc]);

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = data.investor_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose = () => {
    props.onHide();
  };

  const handleRenwDoc = () => {
    let doc_object = [];
    docs.map((eachDoc) => {
      let each_doc = {
        _id: eachDoc._id,
        entity_type: eachDoc.entity_type,
        entity_id: eachDoc.entity_id,
        expiry_date: eachDoc.expiry_date,
        validated_by: eachDoc.validated_by,
        admin_user_id: Cookies.get("admin_user_id"),
        admin_user_name: Cookies.get("admin_user_name"),
      };
      doc_object.push(each_doc);
    });
    axios
      .post(base_url + "documents-type/update_document", doc_object)
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Notified Successfully", {
            toastId: 4,
          });
          props.onHide();

          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else {
          toast.error("Error occurred", {
            toastId: 2,
          });
        }
      });
  };

  const handleDateChange = (e, id, index) => {
    let sch = [...docs];
    let current_date = parseInt(
      Math.round(new Date(e.target.value).getTime() / 1000) + "000"
    );
    sch[index]["expiry_date"] = current_date;
    setDocs(sch);
  };
  const [show, setShow] = useState(false);

  const [selectedDoc, setSelected] = useState([]);

  const handleShowReject = (value) => {
    setSelected(value);
    setShow(true);
  };
  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const handleCloseReject = () => {
    //hit the api from rejection api here
    let document_id = { document_id: selectedDoc.document_id };
    axios
      .post(base_url + "documents-type/delete_document", document_id)
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);
          toast.success("Deleted Successfully", {
            toastId: 4,
          });
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        onHide={handleClose}
        closeButton
        className="modal_title"
        style={{ height: "55px" }}
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Investor Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-2" style={{ height: "28rem" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="row mb-3">
              <div className="col mb-3">
                <p className="text_st">Investor Name</p>
                <div className="bolder_text">
                  {data.investor_name === undefined || data.investor_name === ""
                    ? "-"
                    : data.investor_name}
                </div>

                <div className="mt-3">
                  <p className="text_st">Uploaded By</p>
                  <div className="bolder_text">
                    {data.created_by === undefined || data.created_by === ""
                      ? "-"
                      : data.created_by}
                  </div>
                </div>
              </div>

              <div className="col">
                <p className="text_st">Ref.No</p>
                <div className="bolder_text">
                  {data.investor_reference_no === "" ||
                  data.investor_reference_no === undefined
                    ? "-"
                    : data.investor_reference_no}
                </div>

                <div className="mt-3">
                  <p className="text_st">Created By</p>
                  <div className="bolder_text">
                    {data.created_by === undefined || data.created_by === ""
                      ? "-"
                      : data.created_by}
                  </div>
                </div>
              </div>

              <div className="col">
                <p className="text_st">Company</p>
                <div className="bolder_text">
                  {data.investor_company_name === undefined ||
                  data.investor_company_name === ""
                    ? "-"
                    : data.investor_company_name}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="col-lg-9">
          <div className="row d-flex">
            <div className="col"></div>
            <div className="col-lg-2"></div>
            <div className="col-lg-4 fw-bolder mb-2">
              {doc?.length === 0 ? (
                <div className="no_doc_styl">No Documents</div>
              ) : (
                "Select Expiry"
              )}
            </div>
          </div>
        </div>

        <div className="document_tab_modal col-lg-9">
          {docs?.map((doc, index) => {
            return (
              <>
                <div className="row d-flex mt-3">
                  <div className="col-lg-5">
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : doc.document_type.length > 25 ? (
                      doc.document_type.slice(0, 25) + ".."
                    ) : (
                      doc.document_type
                    )}
                    <p>
                      {doc.expiry_date === null
                        ? ""
                        : "Expiry Date: " +
                          moment(doc.expiry_date).format("DD MMM YYYY")}
                    </p>
                  </div>
                  <div className="doc_icon_repo col-lg-2">
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : (
                      <div className="kyc_tab">
                        <div className="" style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <a
                            style={{ display: "table-cell" }}
                            href={doc.document_url}
                            target="_blank"
                            
                          >
                            <img
                              className=""
                              src="./images/icons/blue_eye.svg"
                              alt=""
                            />
                          </a>
                        </div>
                        <div className=" ps-3 Cpointer" style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <img
                            className="pb-1"
                            src="./images/down.svg"
                            alt=""
                            onClick={() =>
                              handleDownload(
                                doc.document_url,
                                doc.document_type,
                                doc.created_by
                              )
                            }
                          />
                        </div>
                        <div style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <i
                            className=" del_bin_style fa-solid fa-trash"
                            onClick={() => handleShowReject(doc)}
                          ></i>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="expiry_date_pickr col-lg-4 ps-4">
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : (
                      <div>
                        <input
                          autoFocus
                          id="paid_date"
                          type="date"
                          className="form-control rounded custm_border shadow-sm"
                          onChange={(e) => handleDateChange(e, doc._id, index)}
                          placeholder="DD MMM YYYY"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            onClick={handleRenwDoc}
            disabled={props.roleCode===AUDITOR_ROLE}
          >
            Notify To Renew Documents
          </button>
        </div>
      </Modal.Footer>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to delete?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};
